// Unica funzione condivisa (stessa logica di backend/core/contract_math.py) per il MENSILE dei prodotti di contratto.
// Mensile netto = (prezzo scontato × quantità) ÷ mesi di durata. Mensile lordo = mensile netto + IVA.
const num = (v, d = 0) => { const n = Number(String(v ?? "").replace(",", ".")); return v === null || v === undefined || v === "" || Number.isNaN(n) ? d : n; };
const r2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

const monthsBetween = (a, b) => {
  const da = new Date(String(a).slice(0, 10)); const db = new Date(String(b).slice(0, 10));
  if (Number.isNaN(da.getTime()) || Number.isNaN(db.getTime())) return null;
  const m = (db.getFullYear() - da.getFullYear()) * 12 + (db.getMonth() - da.getMonth()) + (db.getDate() >= da.getDate() ? 1 : 0);
  return m > 0 ? m : null;
};

export function productMonths(p, ct = {}) {
  for (const v of [p.accepted_months, p.duration_months, ct.contract_duration, ct.duration_months]) {
    const m = String(v ?? "").match(/\d+/);
    if (m && Number(m[0]) > 0) return Number(m[0]);
  }
  for (const [a, b] of [[p.start_date, p.end_date], [ct.contract_start, ct.contract_end]]) {
    const m = a && b ? monthsBetween(a, b) : null;
    if (m) return m;
  }
  return 1;
}

export const productTotalNet = (p) => r2(num(p.price !== null && p.price !== undefined && p.price !== "" ? p.price : p.monthly_price) * (num(p.quantity, 1) || 1));

export function productMonthly(p, ct = {}) {
  const months = productMonths(p, ct);
  const legacy = p.quantity === null || p.quantity === undefined || p.quantity === "";
  // Contratti storici senza quantità: il prezzo è già la mensilità.
  const raw = legacy ? num(p.price ?? p.monthly_price) : productTotalNet(p) / months;
  const total = legacy ? r2(raw * months) : productTotalNet(p);
  const vat = num(p.vat_rate, 22);
  const k = 1 + vat / 100;
  return { months, totalNet: total, monthlyNet: r2(raw), monthlyGross: r2(raw * k), totalGross: r2(total * k), vat, rawNet: raw, rawGross: raw * k };
}

export function contractMonthly(ct, activeOnly = true) {
  const out = { monthlyNet: 0, monthlyGross: 0, totalNet: 0, totalGross: 0 };
  (ct?.included_products || []).forEach((p) => {
    if (activeOnly && (p.status || "active") !== "active") return;
    if ((p.quantity === null || p.quantity === undefined || p.quantity === "") && (p.una_tantum || p.recurrence === "una_tantum")) return;
    const m = productMonthly(p, ct);
    out.monthlyNet += m.rawNet; out.monthlyGross += m.rawGross; out.totalNet += m.totalNet; out.totalGross += m.totalGross;
  });
  Object.keys(out).forEach((k) => { out[k] = r2(out[k]); });
  return out;
}
